import { Container } from 'react-bootstrap';
import { Route, Routes, useParams } from 'react-router';
import TourEventNavigatorContainer from './tour-event-navigator-container';
import TourEventOverviewContainer from './tour-event-overview-container';
import TourOverviewContainer from './tour-overview-container';

export default function TourHistoryRouter() {
  return (
    <Container>
      <TourEventNavigatorContainer />
      <Routes>
        <Route index element={<TourOverviewContainer />} />
        <Route path=":eventID" element={<TourEventOverviewWithRouteParam />} />
      </Routes>
    </Container>
  );
}

function TourEventOverviewWithRouteParam() {
  const { eventID } = useParams<{ eventID: string }>();
  return <TourEventOverviewContainer eventID={eventID!} />;
}
